import { useState, type ReactNode } from "react";

interface SpoilerSectionProps {
  label?: string;
  /** Whether it starts open. It can always be opened or closed by hand. */
  startOpen: boolean;
  /** Told each time it is opened or closed by hand. */
  onToggle?: (open: boolean) => void;
  children: ReactNode;
}

/** Hidden text that opens on a click. Give it a `key` that changes to start it over. */
export function SpoilerSection({
  label = "Spoilers",
  startOpen,
  onToggle,
  children,
}: SpoilerSectionProps) {
  const [open, setOpen] = useState(startOpen);
  return (
    <div className="timeline-scene-spoilers">
      <button
        type="button"
        className="timeline-scene-spoilers__toggle"
        aria-expanded={open}
        onClick={(event) => {
          setOpen(!open);
          onToggle?.(!open);
          event.currentTarget.blur();
        }}
      >
        <span aria-hidden="true">{open ? "▾" : "▸"}</span> {label}
      </button>
      {open ? children : null}
    </div>
  );
}
